module.exports = __webpack_public_path__ + "static/img/publicar curso 768x1024.e873f8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/publicar/publicar curso 768x1024.jpg
// module id = nLaa
// module chunks = 47